import { render, staticRenderFns } from "./GTextEditor.vue?vue&type=template&id=4d64db1a&scoped=true"
import script from "./GTextEditor.vue?vue&type=script&lang=js"
export * from "./GTextEditor.vue?vue&type=script&lang=js"
import style0 from "./GTextEditor.vue?vue&type=style&index=0&id=4d64db1a&prod&scoped=true&lang=css"
import style1 from "./GTextEditor.vue?vue&type=style&index=1&id=4d64db1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64db1a",
  null
  
)

export default component.exports